import { useState, useEffect, useRef } from 'react';
import { content } from '../content';

const VideoHero = ({ onOpenConsultation }) => {
  // 5 videos: Start with most engaging (human connection), end with nature
  const videos = [
    '/videos/two-women-talking.mp4',   // Most engaging - intimate conversation on couch
    '/videos/coffee-meetup.mp4',       // Professional connection setting
    '/videos/woman-twisting.mp4',      // Yoga movement - shows the practice
    '/videos/support-on-go.mp4',       // Convenience/flexibility
    '/videos/hydrangea-wind.mp4'       // Calming nature element (ending)
  ];

  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRefs = useRef([]);

  useEffect(() => {
    const currentVideo = videoRefs.current[currentVideoIndex];
    if (currentVideo) {
      currentVideo.play().catch(err => {
        console.log(`Video ${currentVideoIndex} autoplay prevented:`, err);
      });
    }
  }, [currentVideoIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [videos.length]);

  return (
    <section id="home" className="relative w-full h-[75vh] lg:h-[85vh] overflow-hidden bg-gray-900">
      {videos.map((video, index) => (
        <video
          key={index}
          ref={(el) => (videoRefs.current[index] = el)}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${
            index === currentVideoIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
          style={{ pointerEvents: 'none' }}
        >
          <source src={video} type="video/mp4" />
        </video>
      ))}
      
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50 z-10" />
      
      {/* Hero Text Overlay */}
      <div className="absolute inset-0 flex items-center justify-center z-20 px-6">
        <div className="max-w-5xl mx-auto text-center space-y-10">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-light serif text-white leading-tight drop-shadow-2xl">
            {content.hero.mainHeading}
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl font-light text-white/95 max-w-4xl mx-auto leading-relaxed drop-shadow-xl">
            {content.hero.subHeading}
          </p>
          <div className="pt-4">
            <button
              onClick={onOpenConsultation}
              className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-10 py-4 rounded-lg text-lg font-medium transition-all duration-300 hover:shadow-2xl transform hover:scale-105 cursor-pointer"
              data-testid="hero-cta-btn"
            >
              {content.hero.buttonText}
            </button>
          </div>
        </div>
      </div>
      
      {/* Navigation dots */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-30">
        {videos.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentVideoIndex(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentVideoIndex
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to video ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default VideoHero;
